import { List, Map } from "immutable";

export default {
  updateVesselInfo: (state, payload) => {
    state.vesselInfos = state.vesselInfos.update(
      payload.id,
      () => payload.data
    );
  },
  updateVessels: (state, vessels) => {
    state.vesselPositions = vessels;
  },
  clearVessels: (state) => {
    state.vesselPositions = Map()
  },
  setCurrentTime: (state, payload) => {
    state.currentTime = payload;
  },
  setVesselMovements: (state, payload) => {
    state.vesselMovements = payload;
  },
  setFeaturesForPoint: (state, payload) => {
    state.featuresForPoint = List(payload);
  },
  setFeaturesForVector: (state, payload) => {
    state.featuresForVector = List(payload);
  },
  setFeaturesForPolygon: (state, payload) => {
    state.featuresForPolygon = List(payload);
  },
  setFeaturesForWake: (state, payload) => {
    state.featuresForWake = List(payload);
  },
  SET_ENTERPRISE_VESSEL: (state, payload) => {
    state.enterpriseVesselMap = Map(payload);
  },
  SET_SELECTED_VESSEL: (state, payload) => {
    state.selectedVesselMap = Map(payload);
  },
}
